import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2c2d33",
      d: "M14.3 12a2.3 2.3 0 0 1-4.6 0 2.3 2.3 0 0 1 4.6 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2c2d33",
      d: "M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0m6.85 14.84c-.03.73-.15 1.24-.32 1.67-.36.93-1.09 1.66-2.01 2.01-.44.17-.94.29-1.67.32s-.97.04-2.84.04-2.11 0-2.84-.04c-.73-.03-1.23-.15-1.67-.32a3.2 3.2 0 0 1-1.22-.8 3.45 3.45 0 0 1-.8-1.22c-.17-.44-.29-.94-.32-1.67s-.04-.97-.04-2.84 0-2.11.04-2.84c.03-.73.15-1.24.32-1.67.17-.46.44-.88.8-1.22.34-.35.76-.62 1.22-.8.44-.17.94-.29 1.67-.32s.97-.04 2.84-.04 2.11 0 2.84.04c.73.03 1.24.15 1.67.32.46.17.88.44 1.22.8.35.34.62.76.8 1.22.17.44.29.94.32 1.67s.04.97.04 2.84 0 2.11-.04 2.84Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2c2d33",
      d: "M17.61 9.22c-.03-.67-.14-1.04-.24-1.28-.11-.3-.29-.57-.52-.79-.22-.23-.49-.41-.79-.52-.24-.09-.61-.21-1.28-.24-.73-.03-.94-.04-2.78-.04s-2.06 0-2.78.04c-.67.03-1.04.14-1.28.24-.3.11-.57.29-.79.52-.23.22-.41.49-.52.79-.09.24-.21.61-.24 1.28-.03.73-.04.94-.04 2.78s0 2.06.04 2.78c.03.67.14 1.04.24 1.28.11.3.29.57.52.79.22.23.49.4.79.52.24.09.61.21 1.28.24.73.03.94.04 2.78.04s2.06 0 2.78-.04c.67-.03 1.04-.14 1.28-.24.6-.23 1.08-.71 1.31-1.31.09-.24.21-.61.24-1.28.03-.73.04-.94.04-2.78s0-2.06-.04-2.78M12 15.54a3.54 3.54 0 1 1 0-7.08 3.54 3.54 0 0 1 0 7.08"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "15.69",
      cy: "8.35",
      r: ".87",
      fill: "#fff"
    }, null, -1)
  ])))
}
export default { render: render }